<div class="event-box" [ngClass]="boxClasses()">
  <a [routerLink]="['/events/' + this.event.id]">
    <div class="event-box__image">
      <img [src]="getImage()" alt="" />
      <div class="event-box__draft-actions" *ngIf="isDraft">
        <button (click)="goToEdit($event)" class="btn btn--primary btn--sm event-box__edit">
          {{ 'EVENT.BOX.edit_event' | translate }}
        </button>
        <button (click)="openDeleteModalDraft($event)" class="btn btn--fill--white btn--sm">
          {{ 'PROJECT.BOX.delete_draft' | translate }}
        </button>
        <div class="event-box__draft-info">
          {{ 'EVENT.BOX.created' | translate }}: {{ dateFromNow() }}
        </div>
      </div>
    </div>
  </a>
  <div class="event-box__bottom">
    <a [routerLink]="['/events/' + this.event.id]">
      <div class="event-box__content">
        <div class="event-box__start-date" [ngClass]="datesClasses()" *ngIf="!isDraft">
          <span class="month">{{ getMonth() }}</span>
          <span class="day">{{ getDay() }}</span>
          <span class="year">{{ getYear() }}</span>
        </div>
        <div class="event-box__info">
          <div class="event-box__info__title">{{ event.name }}</div>
          <div class="event-box__info__address" *ngIf="!isDraft">{{ getAddress() }}</div>
          <div class="event-box__info__time" *ngIf="!isDraft">
            <img src="assets/img/icons/clock-time-eight-outline.svg" />
            {{ getTime() }}
          </div>
          <div class="event-box__info__people" *ngIf="!isDraft">
            <img src="assets/img/icons/account-multiple.svg" />
            {{ peopleInvited }} {{ 'EVENT.people' | translate }}
          </div>
        </div>
      </div>
    </a>
    <div class="event-box__actions" *ngIf="!isProfile && !isDraft && !isClosed">
      <button
        [disabled]="currentUserJoined"
        (click)="joinEvent()"
        *ngIf="displayJoinButton(event)"
        class="btn btn--outline btn--primary btn--sm"
      >
        <span *ngIf="!currentUserJoined">{{ 'EVENT.join' | translate }}</span>
        <span *ngIf="currentUserJoined">{{ 'EVENT.joined_already' | translate }}</span>
      </button>
      <app-ph-drop
        position="bottom center"
        class="drop-mobile--share"
        [classes]="'drop-mobile--share'"
        [additionalOptions]="{ constrainToScrollParent: false }"
      >
        <div class="target">
          <div class="btn btn--outline btn--primary btn--sm btn--share">
            <img src="assets/img/icons/share.svg" alt="{{ 'EVENT.share' | translate }}" />
            <span>{{ 'EVENT.share' | translate }}</span>
          </div>
        </div>
        <div class="content">
          <div class="project__header-share-buttons">
            <app-ph-social-share [shareUrl]="shareUrl" [meta]="meta"></app-ph-social-share>
          </div>
        </div>
      </app-ph-drop>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="displaydeleteModalDraft"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="closeDeleteModalDraft()"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="modal__title">
        {{ 'PROJECT.draft_delete_are_you_sure' | translate }}
      </div>
      <div class="modal__description">
        {{ 'PROJECT.draft_delete_are_you_sure_info' | translate }}
      </div>
      <div class="modal__actions">
        <button class="btn btn--outline btn--md mw-160" (click)="closeDeleteModalDraft()">
          {{ 'GLOBAL.cancel' | translate }}
        </button>
        <button class="btn btn--danger btn--md mw-160" (click)="eventDeleteDraft()">
          {{ 'PROJECT.draft_delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</p-dialog>
